import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell, Legend } from 'recharts';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import { CHART_MARK_STROKE, CHART_MARK_STROKE_WIDTH } from '../../../helpers/chartPalette';

const OTHER_KEY = 'Anders, namelijk..';

const MultipleDevelopmentPieChart = ({ data = [], totalResponses }) => {
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Transform per moment; attach __others only to the OTHER_KEY slice
  const pieData = data.map((entry) => {
    const others = Array.isArray(entry.others) ? entry.others : [];
    return {
      moment: entry.moment,
      data: entry.responses.map((response) => ({
        name: response.name,
        value: response.count,
        color: response.color,
        __others: response.name === OTHER_KEY ? others : [],
      })),
    };
  });

  // Tooltip that shows list of "other" free-text values when hovering OTHER_KEY
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const slice = payload[0]?.payload || {};
    const isOther = slice.name === OTHER_KEY;
    const others = Array.isArray(slice.__others) ? slice.__others : [];

    return (
      <div
        style={{
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: 6,
          padding: 10,
          maxWidth: 320,
        }}
      >
        <p style={{ margin: 0, fontWeight: 600 }}>{slice.name}</p>
        <p style={{ margin: 0 }}>{`Aantal: ${slice.value}`}</p>

        {isOther && others.length > 0 && (
          <div style={{ marginTop: 8 }}>
            <div style={{ fontWeight: 600 }}>{OTHER_KEY}</div>
            <ul style={{ paddingLeft: 16, margin: '4px 0' }}>
              {others.slice(0, 5).map((txt, i) => (
                <li key={`other-${i}`}>{String(txt)}</li>
              ))}
            </ul>
            {others.length > 5 && (
              <div style={{ fontStyle: 'italic' }}>
                +{others.length - 5} meer…
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Custom Legend Renderer (per pie)
  const renderCustomLegend = (props) => {
    const { payload } = props || {};
    if (!payload) return null;
    return (
      <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{ marginBottom: 4, display: 'flex', alignItems: 'center' }}
          >
            <div
              style={{
                width: 10,
                height: 10,
                backgroundColor: entry.color,
                marginRight: 8,
              }}
            />
            <span>{`${entry.payload.name} (${entry.value})`}</span>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={450}>
        <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
          {pieData.map((entry, index) => (
            <div key={`pie-container-${index}`} style={{ textAlign: 'center', width: '45%' }}>
              <h3 style={{ marginBottom: '10px' }}>{entry.moment}</h3>
              <ResponsiveContainer width="100%" height={400}>
                <PieChart>
                  <Pie
                    data={entry.data}
                    dataKey="value"
                    nameKey="name"
                    outerRadius={100}
                    labelLine={false}
                  >
                    {entry.data.map((item, idx) => (
                      <Cell key={`cell-${idx}`} fill={item.color} stroke={CHART_MARK_STROKE} strokeWidth={CHART_MARK_STROKE_WIDTH} />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    content={renderCustomLegend}
                    payload={entry.data.map((d) => ({
                      value: d.value,
                      name: d.name,
                      color: d.color,
                      payload: d,
                    }))}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      </ResponsiveContainer>
    </>
  );
};

export default MultipleDevelopmentPieChart;
